import { CustomerRole } from "features/customer/enums/customerRole";
import FormGroup from "features/shared/forms/components/FormGroup";
import React from "react";
import Select, { OptionsType } from "react-select";
import reactSelectStyles from "features/shared/components/reactSelect/reactselectcustom.module.scss";
import { useTranslation } from "react-i18next";
import { Nullable } from "features/shared/types/nullable";
import AccountRoleDTO from "features/accounts/dtos/AccountRoleDTO";

interface Props {
  name: string;
  onChangeMulti?: (currency: Nullable<AccountRoleDTO[]>) => void;
  onChange?: (contract: Nullable<AccountRoleDTO>) => void;
  isMulti?: boolean;
  disabledRoles?: AccountRoleDTO[];
  errors?: Record<string, string>;
}

const AccountRoleSelect = ({
  name,
  onChange,
  onChangeMulti,
  isMulti = false,
  disabledRoles,
  errors,
}: Props) => {
  // tranlations
  const { t } = useTranslation("customer\\enums\\customerRole");
  const tLabels = useTranslation("accounts\\accounts").t;

  // helpers
  const getRoles = (): AccountRoleDTO[] => {
    return Object.keys(CustomerRole)
      .filter(isValidRole)
      .map((role) => {
        return { role: role as CustomerRole };
      });
  };

  const isValidRole = (role: string): boolean => {
    if (role === CustomerRole.Undefined) {
      return false;
    }

    if (disabledRoles && disabledRoles.some(x => x.role === role)) {
      return false;
    }

    return true;
  }

  // handlers
  const selectChangeHandler = (options: Nullable<AccountRoleDTO | OptionsType<AccountRoleDTO>>) => {
    if (isMulti && onChangeMulti) {
      let typedOptions = options as OptionsType<AccountRoleDTO>;
      let roles = typedOptions.length > 0 ? [...typedOptions] : null;
      onChangeMulti(roles);
    } else if (onChange) {
      onChange(options as AccountRoleDTO);
    }
  }

  // render
  return (
    <FormGroup
      labelText={tLabels("accountRoleSelect.role")}
      validationError={errors ? errors[name] : undefined}
    >
      <Select
        isMulti={isMulti}
        options={getRoles()}
        getOptionLabel={(role) => t(role.role!)}
        getOptionValue={(role) => role.role!}
        isSearchable={false}
        onChange={selectChangeHandler}
        captureMenuScroll={false}
        className={reactSelectStyles.customSelect}
        classNamePrefix="customSelect"
        placeholder={isMulti ? tLabels("accountRoleSelect.selectRoles") : tLabels("accountRoleSelect.selectRole")}
      />
    </FormGroup>
  );
};

export default AccountRoleSelect;
